import React from "react";

type CurveIconProps = {
    className?: string,
};

export const CurveIcon: React.FC<CurveIconProps> = ({className}) => {
    return (
        <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M22.3373 9.35052C20.5728 5.61278 16.7602 3 12.3829 3C8.5567 3 4.99588 4.99588 3 8.25959L16.3726 14L3.07711 19.8652C5.08887 23.0586 8.60887 25 12.3829 25C16.6695 25 20.4163 22.4915 22.2262 18.8763" stroke="#FFF600" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}